import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../Component/Loader";

const TermsService = () => {
  const navigate = useNavigate();

  const [termsCondition, setTermsCondition] = useState();
  const [loading, setLoading] = useState(true);

  const callTermsApi = async () => {
    setLoading(true);
    const ipAddress = localStorage.getItem("ipaddress");
    const token = localStorage.getItem("token");

    await fetch(
      `${process.env.REACT_APP_API_URL}gettermsandconditions?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,

      {
        method: "GET",

        headers: {
          Authorization: `Token ${token}`,

          // "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setTermsCondition(data?.contentList?.[0]);

          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("There was an error, Please try again later.");
      });
  };

  useEffect(() => {
    callTermsApi();
  }, []);

  if (loading) {
    <Loader />;
  }
  return (
    <>
      {" "}
      <Breadcrumb
        mainTitle={"Terms and Conditions"}
        title={"Terms and Conditions"}
        subTitle={"Home"}
      />
      <section class="section-content content-pages">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="rte">
                <p
                  data-aos="zoom-in-left"
                  className=" aos-init"
                  style={{ marginBottom: 25, marginTop: 25 }}
                dangerouslySetInnerHTML={{
                  __html : JSON?.parse(termsCondition?.content || '""'),
                }}
                >
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsService;
